<template>
  <div>
    <label class="heading-2" id="personalHeading">{{ $t('please_fill_in_child_representative') }}</label>
    <p id="required">* - {{ $t('required') }}</p>
    <VeeForm @submit="forward" v-slot="{ errors }">
      <error-container v-if="Object.keys(errors).length > 0" :errors="errors"></error-container>
      <fieldset aria-labelledby="personalHeading">
        <div class="small-form">
          <!-- full name -->
          <Field
            name="fullName"
            rules="required|checkSpecial"
            v-model="name"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="fullName" class="input-container__label"
                  >{{ $t('Name and surname') }}
                  <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="fullName" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- id code -->
          <Field
            name="idCode"
            rules="required|checkSpecial"
            v-model="id"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="idCode" class="input-container__label"
                  >{{ $t('Personal identity code') }}
                  <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="idCode" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- EE document type -->
          <div
            style="margin-bottom: 2.4rem"
            v-if="
              appCountry == 'EE' &&
              groupValue == 'FP' &&
              (appointmentType == 'new_client' || appointmentType == 'account_opening') &&
              branchType == 'video'
            "
          >
            <Field
              name="documentType"
              rules="required|checkSpecial"
              v-model="docType"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
              :validateOnModelUpdate="false"
            >
              <template #default="{ field, errors }">
                <div class="input-container" style="margin-bottom: 3.3rem">
                  <label for="documentType" class="input-container__label" style="margin-bottom: 1.9rem"
                    >{{ $t('document_type') }} <span class="required" :aria-label="$t('required_field')">*</span></label
                  >
                  <div
                    v-for="(document, index) in documentList"
                    :key="index"
                    class="d-flex align-items-center radio-button-margin--small"
                    :class="{ 'radio-button-margin--none': index + 1 == documentList.length }"
                  >
                    <input
                      class="custom-radio"
                      type="radio"
                      name="docType"
                      v-bind="field"
                      :id="document.value"
                      :value="document.value"
                    />
                    <label class="custom-radio-label" :for="document.value">{{ $t(document.name) }}</label>
                  </div>
                  <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                </div>
              </template>
            </Field>
            <Field
              name="documentNumber"
              rules="required|checkSpecial|checkDocumentNumber:@documentType"
              v-model="docNumber"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
              :validateOnModelUpdate="false"
            >
              <template #default="{ field, errors }">
                <div class="input-container">
                  <label for="documentNumber" class="input-container__label"
                    >{{ $t('document_number') }}
                    <span class="required" :aria-label="$t('required_field')">*</span></label
                  >
                  <input type="text" class="input-container__input" id="documentNumber" v-bind="field" />
                  <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                </div>
              </template>
            </Field>
          </div>
          <!-- email -->
          <Field
            name="email"
            rules="required|email|checkSpecial"
            v-model="mail"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="email" class="input-container__label"
                  >{{ $t('E-mail') }} <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="email" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- contact number -->
          <div class="input-container">
            <label for="phonePrefix" class="input-container__label visually-hidden"
              >{{ $t('international_telephone_code') }}
              <span class="required" :aria-label="$t('required_field')">*</span></label
            >
            <label for="number" class="input-container__label"
              >{{ $t('Phone number') }} <span class="required" :aria-label="$t('required_field')">*</span></label
            >
            <div class="d-inline-flex w-100">
              <div class="dropdown__container--small">
                <select class="dropdown dropdown__container--small" v-model="phonePrefix" id="phonePrefix">
                  <option v-for="(code, index) in countryCodeList" :key="index" :value="code.dial_code"
                    >{{ code.code }} +{{ code.dial_code }}</option
                  >
                </select>
              </div>
              <Field
                name="number"
                rules="required|numeric|checkSpecial"
                v-model="phone"
                :validateOnBlur="false"
                :validateOnChange="false"
                :validateOnInput="false"
                :validateOnModelUpdate="false"
              >
                <template #default="{ field, errors }">
                  <div>
                    <input type="text" class="input-container__input w-100" id="number" v-bind="field" />
                    <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                  </div>
                </template>
              </Field>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- Children inputs -->
      <h2 id="childrenHeading" style="margin-top: 55px">{{ $t('please_fill_in_about_child') }}</h2>
      <p id="required">* - {{ $t('required') }}</p>
      <fieldset aria-labelledby="childrenHeading">
        <div
          class="children-form"
          :style="index == 0 ? 'padding-top: 0px' : ''"
          v-for="(item, index) in childrenCount"
          :key="index"
        >
          <div class="small-form">
            <!-- full name -->
            <Field
              :name="`fullName-${index}`"
              rules="required|checkSpecial"
              v-model="childrenData[index].name"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
              :validateOnModelUpdate="false"
            >
              <template #default="{ field, errors }">
                <div class="input-container">
                  <label :for="`fullName-${index}`" class="input-container__label"
                    >{{ $t('Name and surname') }}
                    <span class="required" :aria-label="$t('required_field')">*</span></label
                  >
                  <input type="text" class="input-container__input" :id="`fullName-${index}`" v-bind="field" />
                  <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                </div>
              </template>
            </Field>
            <!-- id code for LT children-->
            <div v-if="appCountry == 'LT' && appointmentType == 'child_onboardingLT'">
              <Field
                :name="`idCode-${index}`"
                rules="min:11|required|checkSpecial|checkLess14"
                v-model="childrenData[index].personal_code"
                :validateOnBlur="false"
                :validateOnChange="false"
                :validateOnInput="false"
                :validateOnModelUpdate="false"
              >
                <template #default="{ field, errors }">
                  <div class="input-container">
                    <label :for="`idCode-${index}`" class="input-container__label"
                      >{{ $t('Personal identity code') }}
                      <span class="required" :aria-label="$t('required_field')">*</span></label
                    >
                    <input type="text" class="input-container__input" :id="`idCode-${index}`" v-bind="field" />
                    <p class="input-container__error" v-if="errors[0]" v-html="errors[0]"></p>
                  </div>
                </template>
              </Field>
            </div>
            <!-- id code -->
            <div v-else>
              <Field
                :name="`idCode-${index}`"
                rules="required|min:5|checkSpecial"
                v-model="childrenData[index].personal_code"
                :validateOnBlur="false"
                :validateOnChange="false"
                :validateOnInput="false"
                :validateOnModelUpdate="false"
              >
                <template #default="{ field, errors }">
                  <div class="input-container">
                    <label :for="`idCode-${index}`" class="input-container__label"
                      >{{ $t('Personal identity code') }}
                      <span class="required" :aria-label="$t('required_field')">*</span></label
                    >
                    <input type="text" class="input-container__input" :id="`idCode-${index}`" v-bind="field" />
                    <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                  </div>
                </template>
              </Field>
            </div>
            <!-- document number -->
            <Field
              :name="`documentNumber-${index}`"
              rules="checkSpecial"
              v-model="childrenData[index].document_number"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
              :validateOnModelUpdate="false"
            >
              <template #default="{ field, errors }">
                <div class="input-container">
                  <label :for="`documentNumber-${index}`" class="input-container__label">{{
                    $t('document_number')
                  }}</label>
                  <input type="text" class="input-container__input" :id="`documentNumber-${index}`" v-bind="field" />
                  <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                </div>
              </template>
            </Field>
          </div>
        </div>
      </fieldset>
      <i18n-t keypath="Terms text" tag="p" class="terms" id="privacyPolicyText">
        <template #X>
          <a :href="termsLink" target="_blank" class="link" aria-labelledby="privacyPolicyText">{{
            $t('Privacy policy')
          }}</a>
        </template>
      </i18n-t>
      <div class="button__wrapper button__wrapper--margin-top-small">
        <button class="button button--secondary" type="button" @click="goBack()">{{ $t('Back') }}</button>
        <button class="button button--primary" type="submit">{{ $t('Continue') }}</button>
      </div>
    </VeeForm>
  </div>
</template>

<script>
import { getCountryURL } from '../utils/countryConfig'
import { mapState, mapActions } from 'pinia'
import { useBookingStore, usePersonalStore } from '../store'
import CountryCodesSortedByCode from '../utils/CountryCodes_SortedByCode'
import ErrorContainer from './ErrorContainer.vue'
import { Form, Field } from 'vee-validate'
import '../vee-validate'
import { I18nT } from 'vue-i18n'

export default {
  name: 'PrivateCustomerChildrenInfo',
  data() {
    return {
      countryCodeList: null,
      errorList: {},
      termsLink: '',
      documentList: [
        { name: 'id_card', value: 'ID-card' },
        { name: 'estonian_passport', value: 'Estonian Passport' },
        { name: 'residence_permit_card', value: 'Residence permit card' },
      ],
      childrenData: [],
    }
  },
  components: {
    ErrorContainer,
    VeeForm: Form,
    Field,
    I18nT,
  },
  created() {
    this.countryCodeList = CountryCodesSortedByCode
    this.initializeChildrenData()
  },
  mounted() {
    this.termsLink = getCountryURL(this.appCountry, this.appLang, 'terms') || getCountryURL('all', 'terms', 'default')
    if (this.countryCode == '') {
      if (this.appCountry == 'LT') {
        this.setCountryCode('370')
      } else if (this.appCountry == 'EE') {
        this.setCountryCode('372')
      } else {
        this.setCountryCode('371')
      }
    }
    //if children data already in state, set children data from state
    if (this.childrenArray.length > 0) {
      this.childrenData = this.childrenArray
    }
  },
  computed: {
    ...mapState(useBookingStore, [
      'appCountry',
      'groupValue',
      'appointmentType',
      'branchType',
      'appLang',
      'childrenCount',
      'childrenArray',
    ]),
    ...mapState(usePersonalStore, [
      'fullName',
      'idCode',
      'email',
      'number',
      'countryCode',
      'documentType',
      'documentNumber',
    ]),
    name: {
      get() {
        return this.fullName
      },
      set(value) {
        this.setFullName(value)
      },
    },
    id: {
      get() {
        return this.idCode
      },
      set(value) {
        this.setIdCode(value)
      },
    },
    mail: {
      get() {
        return this.email
      },
      set(value) {
        this.setEmail(value)
      },
    },
    phonePrefix: {
      get() {
        return this.countryCode
      },
      set(value) {
        this.setCountryCode(value)
      },
    },
    phone: {
      get() {
        return this.number
      },
      set(value) {
        this.setNumber(value)
      },
    },
    docType: {
      get() {
        return this.documentType
      },
      set(value) {
        this.setDocumentType(value)
      },
    },
    docNumber: {
      get() {
        return this.documentNumber
      },
      set(value) {
        this.setDocumentNumber(value)
      },
    },
  },
  methods: {
    ...mapActions(usePersonalStore, [
      'setFullName',
      'setIdCode',
      'setEmail',
      'setNumber',
      'setCountryCode',
      'allowConfirmationView',
      'setDocumentType',
      'setDocumentNumber',
    ]),
    ...mapActions(useBookingStore, ['setChildrenArray']),
    forward() {
      this.setChildrenArray(this.childrenData)
      this.allowConfirmationView(true)
      this.$router.push('/confirmation')
    },
    goBack() {
      this.$router.push('/')
    },
    initializeChildrenData() {
      this.childrenData = Array(this.childrenCount)
        .fill()
        .map(() => ({ name: '', personal_code: '', document_number: '' }))
    },
  },
}
</script>
